import React from "react"
import styles from "./ToolBarSpacer.module.css"

const ToolBarSection = () => (
  <div className={styles.spacer} aria-hidden="true" />
)

export default ToolBarSection
